import styled from 'styled-components'
import { Heading } from 'rebass'

const PdHeading = styled(Heading)`
    padding: ${props => props.fontSize * 0.1 + 'em'} 0;
`
export default PdHeading


// WEBPACK FOOTER //
// ./src/components/Heading.js